import React, { useEffect, useRef, useState } from "react";
import { BackButton, InputWithLabel } from "../../../components/micro";
import { useLocation, useNavigate } from "react-router-dom";
import { headChat } from "../../../assets/image";
import ReactSelect from "react-select";
import FileUploadChoose from "../../../commons/FileUploadChoose";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { InputError } from "../../../commons/MicroComponents";
import FileView from "../components/FileView";
import { uploadFile } from "../../../redux/uploadFile/slice";
import { getCountryData } from "../../../redux/address/slice";
import {
  createServicesRequest,
  serviceRequestsUsers,
} from "../../../redux/serviceRequest/slice";

const ChangeDirectorParticulars = () => {
  const [countryArray, setCountryArray] = useState([]);
  const [directorArray, setDirectorArray] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const user_id = location?.state?.user_id;
  const company_id = location?.state?.company_id;
  const service = location?.state?.service;
  const buttonRef = useRef(null);

  // Selector
  const {
    countryData,
    countryLoading,
    createServicesRequestData,
    createServicesRequestLoading,
    directorData,
  } = useSelector((store) => ({
    // Country Data
    countryData: store?.addressData?.getCountryDataStatus?.data,
    countryLoading: store?.addressData?.getCountryDataStatus?.loading,
    // Service Request Data
    createServicesRequestData:
      store?.serviceRequestData?.createServicesRequestStatus?.data,
    createServicesRequestLoading: store?.serviceRequestData?.loading,
    // Director Data
    directorData: store?.serviceRequestData?.serviceRequestsUsersStatus?.data,
  }));

  useEffect(() => {
    if (!countryData?.data?.length) {
      dispatch(getCountryData());
    }
    if (!directorData?.length) {
      dispatch(
        serviceRequestsUsers({ type: "director", company_id: company_id })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    if (countryData?.data) {
      const data = countryData?.data?.map((x) => ({
        ...x,
        label: x?.name,
      }));
      setCountryArray(data);
    }
    if (directorData?.length) {
      const dataOfDirector = directorData?.map((x) => ({
        ...x,
        label: x?.user?.full_name,
      }));
      setDirectorArray(dataOfDirector);
    }
  }, [countryData, directorData]);

  // handle File Upload
  const handleFileUpload = (fieldName, setFieldValue) => (e) => {
    const file = e?.target?.files[0];
    const type = file?.type;
    const formData = new FormData();
    formData.append("type", "service-request");
    formData.append("file", file);
    formData.append(
      "document_type",
      type === "application/pdf" ? "doc" : "img"
    );

    dispatch(uploadFile(formData)).then((res) => {
      if (res.type === "uploadFile/fulfilled") {
        setFieldValue(fieldName, res.payload.data);
      }
    });
  };

  // Proceed with request
  const handleSubmit = (values) => {
    const payload = {
      details: {
        ...(values.passport && { passport: values.passport?.url }),
        ...(values.ic_front && { ic_front: values.ic_front?.url }),
        ...(values.ic_back && { ic_back: values.ic_back?.url }),
        document_type: values.document_type.value,
        old_id: values.old_id,
        new_id: values.new_id,
        old_address: values.old_address,
        new_address: values.new_address,
        director: values.director,
        home_address: values.home_address,
        director_name: values.director_name,
        nationality_citizenship: values.nationality_citizenship,
      },
      amount:
        service?.service_requests_count < service?.detail?.no_of_free_request
          ? 0
          : service?.detail?.price,
      user_id: user_id,
      company_id: company_id,
      service_id: service?.id,
    };

    dispatch(createServicesRequest(payload)).then((res) => {
      if (res.type !== "createServicesRequest/fulfilled") return;
      const { service_requests_count, detail } = service || {};
      const price = detail?.price || 0;
      if (
        service_requests_count < service?.detail?.no_of_free_request ||
        price <= 0 ||
        detail?.price === undefined
      ) {
        navigate("/approver");
      } else if (buttonRef.current) {
        buttonRef.current.click();
      } else {
        navigate("/approver");
      }
    });
  };

  return (
    <div className="space-y-5">
      <BackButton
        onClick={() => {
          navigate("/service");
        }}
      />
      <div className="flex items-center space-x-5 border-b-2 border-secondary_grey pb-7">
        <img src={headChat} alt="img" />
        <div className="space-y-2 font-ebGaramond">
          <p className="text-xl">We see that you will need a request on:</p>
          <p className="text-3xl">Change of Director’s Particulars</p>
        </div>
      </div>
      {/* Payment Button */}
      <a
        className="hidden"
        ref={buttonRef}
        href={createServicesRequestData?.data?.url}
      >
        Pay Now
      </a>
      <Formik
        initialValues={{
          document_type: "",
          home_address: "",
          director_name: "",
          director: "",
          nationality_citizenship: "",
          old_id: "",
          new_id: "",
          old_address: "",
          new_address: "",
          passport: null,
          ic_front: null,
          ic_back: null,
        }}
        validationSchema={Yup.object().shape({
          home_address: Yup.string().required("home address is required"),
          nationality_citizenship: Yup.string().required(
            "Nationality Citizenship is required"
          ),
          director_name: Yup.string().required("director Name is required"),
          document_type: Yup.object().required("document Type is required"),
          director: Yup.string().required("director is required"),
          old_id: Yup.string().required("Old ID is required"),
          new_id: Yup.string().required("New ID is required"),
          old_address: Yup.string().required("Old Address is required"),
          new_address: Yup.string().required("New Address is required"),
          ic_front: Yup.mixed().when("document_type", {
            is: (document_type) => document_type?.value === "ic",
            then: Yup.mixed().required("IC Front is required"),
          }),
          ic_back: Yup.mixed().when("document_type", {
            is: (document_type) => document_type?.value === "ic",
            then: Yup.mixed().required("IC Back is required"),
          }),
        })}
        onSubmit={(values) => {
          handleSubmit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          setFieldValue,
          handleBlur,
        }) => (
          <Form className="space-y-5">
            <div className="space-y-3 border-b-2 border-secondary_grey pb-3">
              <p className="text-2xl font-ebGaramond">
                Let us guide u though the process:
              </p>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>1.</span>
                <p>Let us know which Director’s Particulars to change</p>
              </div>
              <p className="text-sm">
                Let us know which director’s particular you will like to change
              </p>
              <div>
                <ReactSelect
                  className={"p-0"}
                  id="director"
                  placeholder="Director"
                  options={directorArray}
                  isLoading={createServicesRequestLoading}
                  isClearable={true}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.id}
                  value={
                    directorArray?.length > 0 &&
                    directorArray?.find((op) => {
                      return op.id === values.director;
                    })
                  }
                  onChange={(e) => {
                    setFieldValue("director", e.id);
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: `1px solid ${
                        errors.director && touched.director
                          ? "red"
                          : "#0000003B"
                      }`,
                      borderRadius: "0.3rem",
                      paddingTop: "2px",
                      paddingBottom: "2px",
                      boxShadow: "none",
                      "&:hover": {
                        border: "1px solid #cdddeb",
                      },
                    }),
                  }}
                />
                {errors.director && touched.director ? (
                  <InputError errorTitle={errors.director} />
                ) : null}
              </div>
              <InputWithLabel
                className={
                  errors.old_id && touched.old_id ? "input-error" : "border"
                }
                idFromName={"old_id"}
                value={values.old_id}
                onChange={handleChange}
                onBlur={handleBlur}
                type={"text"}
                label={"Old ID"}
                name="old_id"
                errors={errors.old_id && touched.old_id}
                errorsText={errors.old_id}
              />
              <InputWithLabel
                className={
                  errors.new_id && touched.new_id ? "input-error" : "border"
                }
                idFromName={"new_id"}
                value={values.new_id}
                onChange={handleChange}
                onBlur={handleBlur}
                type={"text"}
                label={"New ID"}
                name="new_id"
                errors={errors.new_id && touched.new_id}
                errorsText={errors.new_id}
              />
              <InputWithLabel
                className={
                  errors.old_address && touched.old_address
                    ? "input-error"
                    : "border"
                }
                idFromName={"old_address"}
                value={values.old_address}
                onChange={handleChange}
                onBlur={handleBlur}
                type={"text"}
                label={"Old Address"}
                name="old_address"
                errors={errors.old_address && touched.old_address}
                errorsText={errors.old_address}
              />
              <InputWithLabel
                className={
                  errors.new_address && touched.new_address
                    ? "input-error"
                    : "border"
                }
                idFromName={"new_address"}
                value={values.new_address}
                onChange={handleChange}
                onBlur={handleBlur}
                type={"text"}
                label={"New Address"}
                name="new_address"
                errors={errors.new_address && touched.new_address}
                errorsText={errors.new_address}
              />
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>2.</span>
                <p>Edit the director particulars</p>
              </div>
              {/* Home Address */}
              <InputWithLabel
                className={
                  errors.home_address && touched.home_address
                    ? "input-error"
                    : "border"
                }
                idFromName={"home_address"}
                value={values.home_address}
                onChange={handleChange}
                onBlur={handleBlur}
                type={"text"}
                label={"Home Address"}
                name="home_address"
                errors={errors.home_address && touched.home_address}
                errorsText={errors.home_address}
              />
              {/* Director Name */}
              <InputWithLabel
                className={
                  errors.director_name && touched.director_name
                    ? "input-error"
                    : "border"
                }
                idFromName={"director_name"}
                value={values.director_name}
                onChange={handleChange}
                onBlur={handleBlur}
                type={"text"}
                label={"Name"}
                name="director_name"
                errors={errors.director_name && touched.director_name}
                errorsText={errors.director_name}
              />
              {/* Nationality / Citizenship */}
              <div>
                <ReactSelect
                  className={"p-0"}
                  id="nationality_citizenship"
                  placeholder="Nationality / Citizenship"
                  options={countryArray}
                  isLoading={countryLoading}
                  isClearable={true}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.id}
                  value={
                    countryArray?.length > 0 &&
                    countryArray?.find((op) => {
                      return op.id === values.nationality_citizenship;
                    })
                  }
                  onChange={(e) => {
                    setFieldValue("nationality_citizenship", e.id);
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: `1px solid ${
                        errors.nationality_citizenship &&
                        touched.nationality_citizenship
                          ? "red"
                          : "#0000003B"
                      }`,
                      borderRadius: "0.3rem",
                      paddingTop: "2px",
                      paddingBottom: "2px",
                      boxShadow: "none",
                      "&:hover": {
                        border: "1px solid #cdddeb",
                      },
                    }),
                  }}
                />
                {errors.nationality_citizenship &&
                touched.nationality_citizenship ? (
                  <InputError errorTitle={errors.nationality_citizenship} />
                ) : null}
              </div>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>3.</span>
                <p>Upload proof of changed particular </p>
              </div>
              <div>
                {/* Upload proof of changed particular */}
                <ReactSelect
                  className={"p-0"}
                  id="document_type"
                  placeholder="Document Type"
                  options={[
                    { value: "ic", label: "IC" },
                    { value: "passport", label: "Passport" },
                  ]}
                  isLoading={false}
                  value={values.document_type}
                  isClearable={true}
                  onChange={(option) => {
                    setFieldValue("document_type", option);
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: `1px solid ${
                        errors.document_type && touched.document_type
                          ? "red"
                          : "#0000003B"
                      }`,
                      borderRadius: "0.3rem",
                      paddingTop: "2px",
                      paddingBottom: "2px",
                      boxShadow: "none",
                      "&:hover": {
                        border: "1px solid #cdddeb",
                      },
                    }),
                  }}
                />
                {errors.document_type && touched.document_type ? (
                  <InputError errorTitle={errors.document_type} />
                ) : null}
              </div>
              {/* Upload IC Front Or Passport */}
              {values.document_type && (
                <div className="space-y-4 border-b-2 border-secondary_grey pb-4">
                  <p className="text-sm">
                    &#8226;{" "}
                    {values.document_type.value === "ic"
                      ? "IC front"
                      : "Passport"}
                  </p>
                  <div>
                    {values?.ic_front || values?.passport ? (
                      <FileView
                        document_type={
                          values.document_type.value === "ic"
                            ? values?.ic_front?.document_type
                            : values?.passport?.document_type
                        }
                        onClose={() =>
                          setFieldValue(
                            values.document_type.value === "ic"
                              ? "ic_front"
                              : "passport",
                            null
                          )
                        }
                        url={
                          values.document_type.value === "ic"
                            ? values?.ic_front?.url
                            : values?.passport?.url
                        }
                      />
                    ) : (
                      <FileUploadChoose
                        errorBorder={
                          values.document_type.value === "ic"
                            ? errors.ic_front && touched.ic_front
                            : errors.passport && touched.passport
                        }
                        name={
                          values.document_type.value === "ic"
                            ? "ic_front"
                            : "passport"
                        }
                        handleFileChange={handleFileUpload(
                          values.document_type.value === "ic"
                            ? "ic_front"
                            : "passport",
                          setFieldValue
                        )}
                      />
                    )}

                    {values.document_type.value === "ic" ? (
                      <>
                        {errors.ic_front && touched.ic_front ? (
                          <InputError errorTitle={errors.ic_front} />
                        ) : null}
                      </>
                    ) : (
                      <>
                        {errors.passport && touched.passport ? (
                          <InputError errorTitle={errors.passport} />
                        ) : null}
                      </>
                    )}
                  </div>
                  {values?.document_type?.value === "ic" && (
                    <>
                      <p className="text-sm">&#8226; IC back</p>
                      {values?.ic_back ? (
                        <FileView
                          document_type={values?.ic_back?.document_type}
                          onClose={() => setFieldValue("ic_back", null)}
                          url={values?.ic_back?.url}
                        />
                      ) : (
                        <div>
                          <FileUploadChoose
                            errorBorder={errors.ic_back && touched.ic_back}
                            name="ic_back"
                            handleFileChange={handleFileUpload(
                              "ic_back",
                              setFieldValue
                            )}
                          />
                          {errors.ic_back && touched.ic_back ? (
                            <InputError errorTitle={errors.ic_back} />
                          ) : null}
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>4.</span>
                <p>Obtain signed resolution</p>
              </div>
              <div className="flex space-x-1 text-theme bg-light_primary_shades rounded-lg px-4 py-3">
                <span>5.</span>
                <p>
                  We will lodge the changes to ACRA for the change of Company
                  Name
                </p>
              </div>
              <p className="text-sm">
                Once the request is opened. You can easily manage it over at
                “On-Going” service page.
              </p>
            </div>
            <div className="flex items-center justify-between space-x-1  bg-light_primary_shades rounded-lg px-4 py-3">
              <p className="font-semibold">Total Payable :</p>
              <div>
                <p className="text-xs">
                  {service?.service_requests_count}/
                  {service?.detail?.no_of_free_request ?? 0} used
                </p>
                <p>
                  {service?.service_requests_count >=
                  service?.detail?.no_of_free_request
                    ? `$${service?.detail?.price}`
                    : "Free"}
                </p>
              </div>
            </div>
            <div className="box !rounded-xl flex items-center justify-between">
              <button
                type="submit"
                className={`${
                  createServicesRequestLoading
                    ? "btn-outline-disabled"
                    : "btn-theme"
                }  uppercase`}
                disabled={createServicesRequestLoading}
              >
                {createServicesRequestLoading
                  ? "Loading.."
                  : "Proceed with request"}
              </button>
              <div>
                <p className="text-xs">Total:</p>
                <p className="text-xl">
                  {service?.service_requests_count >=
                  service?.detail?.no_of_free_request
                    ? `$${service?.detail?.price}`
                    : "Free"}
                </p>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ChangeDirectorParticulars;
